<div class="left">
  <app-cars-with-events-list (carSelected)="selectedCar = $event"></app-cars-with-events-list>
</div>
<div clasS="right">
  <app-car-event-conversation
    [profileId]="selectedCar?.id"
    (createEventClicked)="onCreateEventClicked($event)"></app-car-event-conversation>
</div>
